module.exports = __webpack_public_path__ + "img/con_complete.6694f89e.svg";